import * as React from "react";

function SvgComponent(
  props: JSX.IntrinsicAttributes & React.SVGProps<SVGSVGElement>
) {
  return (
    <svg
      width={20}
      height={20}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M15.661 3.692a1.123 1.123 0 011.19.17c.166.139.294.321.37.53.077.208.1.434.065.655L15.499 16.51c-.173 1.106-1.32 1.74-2.279 1.189a45.564 45.564 0 01-3.064-1.912c-.536-.37-2.177-1.558-1.975-2.403.173-.723 2.93-3.438 4.506-5.052.618-.634.336-1-.394-.416-1.814 1.448-4.725 3.65-5.688 4.27-.85.547-1.292.64-1.821.547-.966-.17-1.862-.433-2.593-.754-.988-.433-.94-1.87 0-2.288l13.47-6z"
        fill={props.color ?? "#23262F"}
      />
    </svg>
  );
}

export default SvgComponent;
